// Deep imports rather than the `@/features/hazards` barrel. The barrel exports `./data` before
// `./domain`, so a mapper reaching back through it for an enum is evaluated while `./domain` is
// still initialising and sees `undefined` — which makes this module, and anything importing it,
// impossible to load in isolation (KUDO1-9541).
import { HAZARD_MARKERS } from '@/features/hazards/utils/constants';
import { FdrSubType } from '@/features/hazards/domain/entities/types/entity-sub-type/fire-danger-ratings';
import type { PolygonScheme, Scheme } from '@/features/hazards/domain/entities/types/scheme';

export type FireDangerWarningsScheme = Scheme & {
  polygonScheme: PolygonScheme;
};

type FireDangerWarningsToSchemeMap = Record<FdrSubType, FireDangerWarningsScheme>;
export const fireDangerWarningsToSchemeMap: FireDangerWarningsToSchemeMap = {
  [FdrSubType.CatastrophicFdrEntity]: {
    icon: HAZARD_MARKERS['ew-fdr-catastrophic'],
    polygonScheme: {
      fill: '#AD0909',
      'fill-opacity': 0.2,
      stroke: '#000000',
      'stroke-width': 1,
    },
  },
  [FdrSubType.ExtremeFdrEntity]: {
    icon: HAZARD_MARKERS['ew-fdr-extreme'],
    polygonScheme: {
      fill: '#F78100',
      'fill-opacity': 0.5,
      stroke: '#000000',
      'stroke-width': 1,
    },
  },
  [FdrSubType.HighFdrEntity]: {
    icon: HAZARD_MARKERS['ew-fdr-high'],
    polygonScheme: {
      fill: '#FEDD3A',
      'fill-opacity': 0.5,
      stroke: '#000000',
      'stroke-width': 1,
    },
  },
  [FdrSubType.ModerateFdrEntity]: {
    icon: HAZARD_MARKERS['ew-fdr-moderate'],
    polygonScheme: {
      fill: '#64BF30',
      'fill-opacity': 0.5,
      stroke: '#000000',
      'stroke-width': 1,
    },
  },
  [FdrSubType.NoRatingFdrEntity]: {
    icon: HAZARD_MARKERS['ew-fdr-no-rating'],
    polygonScheme: {
      fill: '#FFFFFF',
      'fill-opacity': 0.5,
      stroke: '#000000',
      'stroke-width': 1,
    },
  },
};
